if (window.location.pathname.includes("admin/maintenance")) {
  const options = {
    autoWidth: false,
    responsive: false,
    scrollY: 500,
    scrollX: true,
    columnDefs: [
      {
        render: (data, type, row, meta) => meta.row + 1,
        width: "10px",
        targets: "col-id"
      },
      {
        render: (data, type, row) => `<a href="/placement/edit/${row.placement_id}">${data}</a>`,
        targets: "col-policyholder"
      },
      {
        render: function(data, type, row) {
          return `<span class="d-none">${data || ""}</span><input class="migrate-hotel" type="checkbox" data-hotel_placement_id="${row.id}" ${
            !data ? "disabled checked" : ""
          } />`;
        },
        targets: "col-is_legacy"
      }
    ],
    buttons: [{ extend: "excel", text: '<i class="fas fa-file-download"></i>' }]
  };

  $.each($(".table-hotel-legacy"), function() {
    $(this).data("options", options);
  });

  $("body").on("change", ".migrate-hotel", function() {
    const card = $(this).parents(".card");
    const btnGroup = card.find(".card-header .dt-buttons.btn-group.flex-wrap");
    if (!card.find(".card-body .migrate-hotel:checked:not(:disabled)").length) {
      btnGroup.find(".btn-migrate").remove();
    } else if (!btnGroup.find(".btn-migrate").length) {
      btnGroup.prepend(`<button class="btn btn-secondary text-nowrap btn-migrate">Migrate Selected</button>`);
    }
  });

  $("body").on("click", ".btn-migrate", function() {
    const ids = [];
    const card = $(this).parents(".card");

    card.find(".card-body .migrate-hotel:checked:not(:disabled)").each(function() {
      ids.push($(this).data("hotel_placement_id"));
    });

    Swal.fire({
      title: "Migrate Hotel",
      html: `<div id="hotel-migrate">
            <form v-for="hotel_placement in hotel_placements" action="/api/hotel_placement/update" method="POST" class="text-left text-sm live-form card mb-3" data-model="placement.hotel_placements" :data-model_id="hotel_placement.id">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <span>{{hotel_placement.placement.policyholder.name}}</span>
                    <button type="button" data-toggle-alt="true"
                        class="btn btn-outline-white form-btn px-2 py-1 collapsed"
                        data-toggle="collapse"
                        :data-target="'#hotel-placement-' + hotel_placement.id"
                        aria-expanded="false"
                        :aria-controls="'hotel-placement-' + hotel_placement.id">
                    </button>
                </div>
                <div :id="'hotel-placement-' + hotel_placement.id" class="card-body collapse">
                    <v-hotel-placement :placement="hotel_placement.placement" :hotel_placement="hotel_placement" :is_legacy="false" :is_migrating="true"></v-hotel-placement>
                    <v-hidden v-model="hotel_placement.id" class="form-control d-none" name="id"></v-hidden>
                    <v-hidden v-model="hotel_placement.hotel_id" class="form-control d-none" name="hotel_id"></v-hidden>
                    <v-hidden v-model="hotel_placement.placement.id" class="form-control d-none" name="placement_id"></v-hidden>
                </div>
                <div class="card-footer"></div>
            </form>
        </div>`,
      icon: undefined,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: "Migrate",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      width: 1024,
      heightAuto: false,
      preConfirm: async () => {
        try {
          const result = await new Promise((resolve, reject) => {
            $.ajax({
              url: `/api/hotel_placement/migrate`,
              method: "POST",
              data: { ids },
              dataType: "json",
              success: response => resolve(response),
              error: response => reject(response)
            });
          });

          card.find(".card-body .migrate-hotel:checked:not(:disabled)").each(function() {
            $(this).attr("disabled", true);
          });

          return result;
        } catch (e) {
          Swal.showValidationMessage(`There is something wrong!`);
        }
      },
      onRender: () => {
        Swal.showLoading();

        $.ajax({
          url: "/api/hotel_placement/read",
          method: "POST",
          data: { ids },
          success: function(response) {
            new Vue({
              el: `#hotel-migrate`,
              data: {
                hotel_placements: [...response],
                hotel_placement_clones: window.app_data.hotel_placement_clones,
                models: window.app_models,
                options: window.app_options
              },
              methods: {
                room_clone(id) {
                  this.$set(this.hotel_placement_clones, id, {
                    create_url: "/api/hotel_placement_room/create",
                    create_data: {
                      hotel_placement_id: id
                    },
                    delete_url: "/api/hotel_placement_room/delete",
                    model: this.models.room
                  });

                  return "hotel_placement_clones." + id;
                },
                hotel_change(id) {
                  setTimeout(() => {
                    $("[action='/api/hotel_placement/update'][data-model_id='" + id + "']")
                      .find("[name='hotel_id']")
                      .trigger("change");
                  }, 500);
                }
              },
              computed: {
                placement_hotels() {
                  return this.options.hotels;
                }
              }
            });
            Swal.hideLoading();
          },
          error: function(error) {
            Swal.hideLoading();
            Swal.showValidationMessage(`Error getting hotel data!`);
            console.error("Error getting hotel data:", error);
          }
        });
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Submitted", "Successfully migrated.", "success");
      }
    });
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/admin/maintenance.js